import { endpoints, request } from '!core/api';

export const logoutServices = {
  logout: ({ username, loginId }) =>
    request.postWebService(endpoints.webservices('logout'), {
      username,
      loginId,
    }),
};
